import React, { useState, useEffect } from 'react';
import './home.css';
import About from './about';
import Contact from './contact';

export default function Home() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showImage, setShowImage] = useState(false);
  const [showAbout, setShowAbout] = useState(false);
  const [showContact, setShowContact] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState('All');

  const handleFilterChange = (filter) => {
    setSelectedFilter(filter);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 120) {
        setShowImage(true);
      } else {
        setShowImage(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const images = [
    { src: 'images/isro.png', alt: 'isro', name: 'Space & Defence' },
    { src: 'images/drdo.png', alt: 'drdo', name: 'Space & Defence' },
    { src: 'images/cpri.png', alt: 'cpri', name: 'Institutes' },
    { src: 'images/csir-nal.png', alt: 'csir-nal', name: 'Central Govt & Public Sector' },
    { src: 'images/beml.png', alt: 'beml', name: 'Central Govt & Public Sector' },
    { src: 'images/c-dot.png', alt: 'c-dot', name: 'Banks' },
    { src: 'images/barc.png', alt: 'barc', name: 'Space & Defence' },
    { src: 'images/be.png', alt: 'be', name: 'Central Govt & Public Sector' },
    { src: 'images/ec.png', alt: 'ec', name: 'banks' },
    { src: 'images/hal.png', alt: 'hal', name: 'Central Govt & Public Sector' },
    { src: 'images/ksphc.png', alt: 'ksphc', name: 'Govt of Karnataka' },
    { src: 'images/khb.png', alt: 'khb', name: 'Govt of Karnataka' },
    { src: 'images/kfcsc.png', alt: 'kfcsc', name: 'Govt of Karnataka' },
    { src: 'images/rri.png', alt: 'rri', name: 'Govt of Karnataka' },
    { src: 'images/bvs.png', alt: 'bvs', name: 'Institutes' },
    { src: 'images/syndicate.png', alt: 'syndicate', name: 'Banks' },
  ];

  const filteredImages = selectedFilter === 'All' 
  ? images 
  : images.filter((image) => image.name.toLowerCase() === selectedFilter.toLowerCase());

  document.addEventListener("DOMContentLoaded", () => {
    const navLinks = document.querySelectorAll("nav a");
    const sections = document.querySelectorAll("section");
  
    // Function to update the selected class
    const updateSelectedClass = (id) => {
      navLinks.forEach(link => {
        link.classList.remove("selected");
        if (link.getAttribute("href") === `#${id}`) {
          link.classList.add("selected");
        }
      });
    };
  
    // IntersectionObserver to observe sections
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          updateSelectedClass(entry.target.id);
        }
      });
    }, { threshold: 0.2 }); // Trigger when 20% of the section is visible
  
    // Observe each section
    sections.forEach(section => observer.observe(section));
  
    // Add click event listeners for manual selection
    navLinks.forEach(link => {
      link.addEventListener("click", (event) => {
        navLinks.forEach(link => link.classList.remove("selected"));
        event.target.classList.add("selected");
      });
    });
  });

  const handleNavItemClick = () => {
    setMobileMenuOpen(false); // Hide the menu when a nav item is clicked
  };

  return (
    <div className="flex flex-col min-h-screen">
      <header className="sticky top-0 z-10 bg-header header_top">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          <a href="/" className="flex items-center gap-2 pl-24 md:pl-64">
            <img src="images/dopo-logo.svg" alt="Dopo Logo" width={60} height={34} className={showImage ? "image-visible" : "image-hidden"} />
          </a>

          {/* Mobile Menu Button */}
          <div className='md:hidden flex items-center gap-32 ml-auto'>
            <button
              onClick={() => {
                window.location.href = "tel:+919448321546"; // Replace with the desired phone number
              }}
            >
              <img src="images/phone-call.svg" alt="Menu Close" width={24} height={24} />
            </button>

            <button className="" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
              {mobileMenuOpen ? <img src="images/close.svg" alt="Menu Close" width={24} height={24} /> : <img src="images/menu-icon.svg" alt="Menu Open" width={24} height={24} />}
            </button>
          </div>

          {/* Desktop Navigation */}
          <div className='flex items-center gap-64'>
            <nav className="hidden md:flex items-center space-x-6">
              <a href="#home" className="header-menu-color text-sm font-normal hover:text-coral-600 selected home">
                Home
              </a>
              <a href="#solutions" className="header-menu-color text-sm font-normal hover:text-coral-600">
                Solutions
              </a>
              <a href="#services" className="header-menu-color text-sm font-normal hover:text-coral-600">
                Services
              </a>
              <a href="#partners" className="header-menu-color text-sm font-normal hover:text-coral-600">
                Partners
              </a>
              <a href="#clients" className="header-menu-color text-sm font-normal hover:text-coral-600">
                Clients
              </a>
              <a href="#contact" className="header-menu-color text-sm font-normal hover:text-coral-600">
                Contact Us
              </a>
              <a href="#about" className="header-menu-color text-sm font-normal hover:text-coral-600 about-us" onClick={() => setShowAbout(true)}>
                About Us
              </a>
            </nav>

            <div className="hidden md:flex items-center gap-2">
              <img src='images/phone.png' width={28} height={28} alt='Phone' />
              <span className="header-menu-color text-sm font-semibold">+91 9448321546</span>
            </div>

            <div className="hidden md:flex items-center">
              <button 
                className='reach-us header-menu-color'
                onClick={() => setShowContact(true)}
              >
                  Reach Us
              </button>
            </div>

          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-8 px-8 mobile-menu">
            <nav className="flex flex-col space-y-4">
              <a onClick={handleNavItemClick} href="#home" className="header-menu-color text-sm font-medium hover:text-coral-600 selected">
                Home
              </a>
              <a onClick={handleNavItemClick} href="#solutions" className="header-menu-color text-sm font-medium hover:text-coral-600">
                Solutions
              </a>
              <a onClick={handleNavItemClick} href="#services" className="header-menu-color text-sm font-medium hover:text-coral-600">
                Services
              </a>
              <a onClick={handleNavItemClick} href="#partners" className="header-menu-color text-sm font-medium hover:text-coral-600">
                Partners
              </a>
              <a onClick={handleNavItemClick} href="#clients" className="header-menu-color text-sm font-normal hover:text-coral-600">
                Clients
              </a>
              <a onClick={handleNavItemClick} href="#contact" className="header-menu-color text-sm font-medium hover:text-coral-600">
                Contact Us
              </a>
              <a href="#about" className="header-menu-color text-sm font-normal hover:text-coral-600" onClick={() => setShowAbout(true)}>
                About Us
              </a>
            </nav>
          </div>
        )}
      </header>

      {/* <About /> */}

      <main className="flex-grow">
        {/* Hero Section */}
        <section className="bg-home" id="home">
          <div className="container mx-auto px-4 grid md:grid-cols-2 items-center">
            <div className='bg-home-banner md:bg-home-banner bg-home-banner-mobile lg:p-16 md:p-6 p-6' style={{paddingBottom: "24px"}}>
              <img src="images/dopo-logo.svg" alt="Dopo Logo" width={147} height={82} className="mb-8" />
              <h1 className="text-3xl md:text-4xl lg:text-5xl text-gray-800 leading-tight">
                <span className='font-normal text-blue'>Empowering</span>
                <br />
                <span className='text-coral-600 font-bold'>Digital</span>
                <br />
                <span className="font-semibold text-blue">Transformation</span>
              </h1>
              <p className="mt-4 md:mt-6 lg:mt-6 text-sm md:text-base header-para-color max-w-md lg:text-xl">
                Leading India’s IT revolution, we create cutting-edge solutions that transform enterprises and enhance digital experiences, empowering businesses to scale, adapt, and thrive in a dynamic tech landscape.
              </p>
              <div>
                <img src="images/iso.svg" alt="ISO" className="mb-8 mt-8" />
              </div>
              <button className="lg:mt-4 md:mt-4 hidden md:flex items-center gap-2 text-base text-blue">
                <img src="images/arrow-down.svg" alt="Arrow Down" width={24} height={24} />
                Scroll down
              </button>
            </div>
            <div className="flex justify-center md:justify-end mt-8 md:mt-0">
              <img 
                src="images/technology-banner.png" 
                alt="IT Infrastructure Illustration" 
                width="1024" 
                height="1024"
                className="w-full" 
              />
            </div>
            <button className="lg:mt-8 md:mt-8 md:hidden flex items-center justify-center gap-2 text-base text-blue" style={{position: "relative", top: "-35px"}}>
              <img src="images/arrow-down.svg" alt="Arrow Down" width={24} height={24} />
              Scroll down
            </button>
          </div>
        </section>

        {/* Our Solutions Section */}
        <section className="bg-our-solution" id="solutions">
          <div className="container mx-auto px-4">
            <div className="mb-4 our-solution-top lg:p-16 md:p-6 p-6">
              <span className="text-coral-600 font-semibold text-2xl">Our Solutions</span>
              <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold offering-list-title-color mt-2">
                Empowering Your Digital Evolution
              </h2>
              <p className="hidden md:flex mt-4 text-sm md:text-lg offering-list-color">
                Our solutions span the full spectrum of IT needs—from end-user devices to core infrastructure. We deliver secure, scalable, and future-ready technologies tailored to your business.
                Whether you’re enhancing productivity, storage, networking, or security—we’ve got you covered. Designed to integrate seamlessly and evolve with your organization’s growth.
              </p>
              <p className="md:hidden mt-4 text-sm md:text-lg offering-list-color">
                Our solutions span the full spectrum of IT needs—from end-user devices to core infrastructure. We deliver secure, scalable, and future-ready technologies tailored to your business.
              </p>
            </div>

            {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 md:gap-8"> */}
            <div>
              
              {/* End Computing */}
              <div className="bg-end-computing mb-4">
                <div className='flex flex-col md:flex-row'>
                  <div className='end-computing-left-bg lg:p-16 md:p-6 p-6 pr-0 w-full lg:w-half md:w-half'>
                    <h3 className="lg:text-2halfxl md:text-xl text-xl font-semibold offering-title-color">End Computing</h3>
                    <p className="mt-6 text-sm md:text-lg offering-para-color">
                      Enhance user experience with secure, flexible technologies that enhance productivity and
                      collaboration. Build a future-ready environment that seamlessly adapts to evolving devices, workflows,
                      and user expectations for maximum efficiency.
                    </p>
                    <div className="mt-8 md:mt-6 lg:mt-6 offering_container">
                      <h4 className="text-base lg:text-xl md:text-xl font-bold offering-list-title-color">Our offerings</h4>
                      <ul className="mt-2 md:mt-3 grid grid-cols-1 sm:grid-cols-2 gap-1 md:gap-2">
                        <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                          <img 
                            src="images/arrow-right.svg"
                            alt="Arrow Right"
                            width={14}
                            height={14}
                          />
                          Desktops
                        </li>
                        <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                          <img 
                            src="images/arrow-right.svg"
                            alt="Arrow Right"
                            width={14}
                            height={14}
                          />
                          Mobile Workstations
                        </li>
                        <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                          <img 
                            src="images/arrow-right.svg"
                            alt="Arrow Right"
                            width={14}
                            height={14}
                          />
                          Laptops
                        </li>
                        <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                          <img 
                            src="images/arrow-right.svg"
                            alt="Arrow Right"
                            width={14}
                            height={14}
                          />
                          Printers & Scanners
                        </li>
                        <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                          <img 
                            src="images/arrow-right.svg"
                            alt="Arrow Right"
                            width={14}
                            height={14}
                          />
                          Tablets
                        </li>
                        <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                          <img 
                            src="images/arrow-right.svg"
                            alt="Arrow Right"
                            width={14}
                            height={14}
                          />
                          Unified Communications
                        </li>
                        <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                          <img 
                            src="images/arrow-right.svg"
                            alt="Arrow Right"
                            width={14}
                            height={14}
                          />
                          Thin Clients
                        </li>
                        <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                          <img 
                            src="images/arrow-right.svg"
                            alt="Arrow Right"
                            width={14}
                            height={14}
                          />
                          Display Solutions
                        </li>
                        <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                          <img 
                            src="images/arrow-right.svg"
                            alt="Arrow Right"
                            width={14}
                            height={14}
                          />
                          Workstations
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="flex justify-end end-computing-right-bg w-full lg:w-half md:w-half" style={{minHeight: "400px"}}>
                    {/* <div className="w-half lg:w-auto md:w-auto">
                      <img
                        src="images/end-computing.png"
                        alt="End Computing Illustration"
                        width={530}
                        height={530}
                        // className="w-full"
                      />
                    </div> */}
                  </div>
                </div>

              </div>

              {/* Server */}
              <div className="bg-server mb-4">
                <div className='flex flex-col-reverse flex-col md:flex-row'>
                  <div className="flex justify-end server-left-bg w-full lg:w-half md:w-half" style={{minHeight: "400px"}}>
                      {/* <div className="w-half lg:w-auto md:w-auto">
                        <img
                          src="images/server.png"
                          alt="Server Solutions Illustration"
                          width={400}
                          height={400}
                          // className="w-full"
                        />
                      </div> */}
                  </div>
                  <div className='server-right-bg lg:p-16 md:p-6 p-6 pr-0 w-full lg:w-half md:w-half'>
                    <h3 className="lg:text-2halfxl md:text-xl text-xl font-semibold offering-title-color">Server</h3>
                    <p className="mt-6 text-sm md:text-lg offering-para-color">
                      We provide reliable, industry-standard server infrastructure with versatile configurations, simplified
                      management, and scalable flexibility. Our next-gen servers offer exceptional performance, value, and
                      energy efficiency.
                    </p>

                    <div className="mt-8 md:mt-6 lg:mt-6 offering_container p-4 lg:p-8 md:p-6 pl-0">
                      <h4 className="text-base lg:text-xl md:text-xl font-bold offering-list-title-color">Our offerings</h4>
                      <ul className="mt-2 md:mt-3 grid grid-cols-1 sm:grid-cols-2 gap-1 md:gap-2">
                        <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                          <img 
                            src="images/arrow-right.svg"
                            alt="Arrow Right"
                            width={14}
                            height={14}
                          />
                          Tower Servers
                        </li>
                        <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                          <img 
                            src="images/arrow-right.svg"
                            alt="Arrow Right"
                            width={14}
                            height={14}
                          />
                          Modular Servers
                        </li>
                        <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                          <img 
                            src="images/arrow-right.svg"
                            alt="Arrow Right"
                            width={14}
                            height={14}
                          />
                          Industrial Grade Servers
                        </li>
                        <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                          <img 
                            src="images/arrow-right.svg"
                            alt="Arrow Right"
                            width={14}
                            height={14}
                          />
                          Rack Servers
                        </li>
                        <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                          <img 
                            src="images/arrow-right.svg"
                            alt="Arrow Right"
                            width={14}
                            height={14}
                          />
                          Converged System Solutions
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className='flex gap-4 flex-col md:flex-row'>
                {/* Networking */}
                <div className="lg:p-16 md:p-6 p-6 bg-networking relative mb-4">
                  <h3 className="lg:text-2halfxl md:text-xl text-xl font-semibold offering-title-color">Networking</h3>
                  <p className="mt-6 text-sm md:text-lg offering-para-color">
                    Innovative network solutions that boost security, improve efficiency, and support modern technology
                    adoption.
                  </p>

                  <div className="mt-8 md:mt-6 lg:mt-7 offering_container">
                    <h4 className="text-base lg:text-xl md:text-xl font-bold offering-list-title-color">Our offerings</h4>
                    <ul className="mt-2 md:mt-3 grid gap-1 md:gap-2">
                      <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                        <img 
                          src="images/arrow-right.svg"
                          alt="Arrow Right"
                          width={14}
                          height={14}
                        />
                        Routers
                      </li>
                      <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                        <img 
                          src="images/arrow-right.svg"
                          alt="Arrow Right"
                          width={14}
                          height={14}
                        />
                        Switches
                      </li>
                      <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                        <img 
                          src="images/arrow-right.svg"
                          alt="Arrow Right"
                          width={14}
                          height={14}
                        />
                        Enterprise Solutions
                      </li>
                      <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                        <img 
                          src="images/arrow-right.svg"
                          alt="Arrow Right"
                          width={14}
                          height={14}
                        />
                        Wireless Networking Solutions
                      </li>
                      <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                        <img 
                          src="images/arrow-right.svg"
                          alt="Arrow Right"
                          width={14}
                          height={14}
                        />
                        Software-Defined Networking
                      </li>
                      <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                        <img 
                          src="images/arrow-right.svg"
                          alt="Arrow Right"
                          width={14}
                          height={14}
                        />
                        Network Security Solutions
                      </li>
                      <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                        <img 
                          src="images/arrow-right.svg"
                          alt="Arrow Right"
                          width={14}
                          height={14}
                        />
                        Network Monitoring &amp; Management
                      </li>
                      <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                        <img 
                          src="images/arrow-right.svg"
                          alt="Arrow Right"
                          width={14}
                          height={14}
                        />
                        Structured Cabling Solution
                      </li>
                      <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                        <img 
                          src="images/arrow-right.svg"
                          alt="Arrow Right"
                          width={14}
                          height={14}
                        />
                        Voice Solutions
                      </li>
                    </ul>
                  </div>
                  <div className="mt-4 md:mt-6 networking-img-container w-half lg:w-auto md:w-auto">
                      <img
                        src="images/networking.png"
                        alt="Networking Solutions Illustration"
                        width={380}
                        height={380}
                        // className="w-full"
                      />
                    </div>
                </div>

                {/* Storage */}
                <div className="lg:p-16 md:p-6 p-6 bg-storage relative mb-4">
                  <h3 className="lg:text-2halfxl md:text-xl text-xl font-semibold offering-title-color">Storage</h3>
                  <p className="mt-6 text-sm md:text-lg offering-para-color">
                    End-to-end storage ensures fast access, flexible scaling, and seamless integration across any
                    infrastructure.
                  </p>

                  <div className="mt-8 md:mt-6 lg:mt-7 offering_container">
                    <h4 className="text-base lg:text-xl md:text-xl font-bold offering-list-title-color">Our offerings</h4>
                    <ul className="mt-2 md:mt-3 grid gap-1 md:gap-2">
                      <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                        <img 
                          src="images/arrow-right.svg"
                          alt="Arrow Right"
                          width={14}
                          height={14}
                        />
                        Direct Attached Storage (DAS)
                      </li>
                      <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                        <img 
                          src="images/arrow-right.svg"
                          alt="Arrow Right"
                          width={14}
                          height={14}
                        />
                        Network Area Storage (NAS)
                      </li>
                      <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                        <img 
                          src="images/arrow-right.svg"
                          alt="Arrow Right"
                          width={14}
                          height={14}
                        />
                        Storage Area Network (SAN)
                      </li>
                      <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                        <img 
                          src="images/arrow-right.svg"
                          alt="Arrow Right"
                          width={14}
                          height={14}
                        />
                        Cloud Storage
                      </li>
                      <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                        <img 
                          src="images/arrow-right.svg"
                          alt="Arrow Right"
                          width={14}
                          height={14}
                        />
                        Flash Storage
                      </li>
                      <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                        <img 
                          src="images/arrow-right.svg"
                          alt="Arrow Right"
                          width={14}
                          height={14}
                        />
                        Software Defined Storage (SDS)
                      </li>
                      <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                        <img 
                          src="images/arrow-right.svg"
                          alt="Arrow Right"
                          width={14}
                          height={14}
                        />
                        Backup and Recovery Solutions
                      </li>
                      <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                        <img 
                          src="images/arrow-right.svg"
                          alt="Arrow Right"
                          width={14}
                          height={14}
                        />
                        Data Storage Management
                      </li>
                    </ul>
                </div>
                <div className="mt-4 md:mt-6 storage-img-container w-half lg:w-auto md:w-auto">
                  <img
                    src="images/storage.png"
                    alt="Storage Solutions Illustration"
                    width={300}
                    height={300}
                    // className="w-full"
                  />
                </div>
              </div>
              </div>

              <div className='flex gap-4 flex-col md:flex-row'>
               {/* Security Solutions */}
                <div className="lg:p-16 md:p-6 p-6 bg-security-solutions relative">
                  <h3 className="lg:text-2halfxl md:text-xl text-xl font-semibold offering-title-color">Security Solutions</h3>
                  <p className="mt-6 text-sm md:text-lg offering-para-color">
                    We provide continuous monitoring, security incident and event monitoring and analytical capabilities
                    of your IT infrastructure.
                  </p>

                  <div className="mt-8 md:mt-6 lg:mt-7 offering_container">
                    <h4 className="text-base lg:text-xl md:text-xl font-bold offering-list-title-color">Our offerings</h4>
                    <ul className="mt-2 md:mt-3 grid gap-1 md:gap-2">
                      <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                        <img 
                          src="images/arrow-right.svg"
                          alt="Arrow Right"
                          width={14}
                          height={14}
                        />
                        Firewall
                      </li>
                      <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                        <img 
                          src="images/arrow-right.svg"
                          alt="Arrow Right"
                          width={14}
                          height={14}
                        />
                        End Point Security Solution
                      </li>
                      <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                        <img 
                          src="images/arrow-right.svg"
                          alt="Arrow Right"
                          width={14}
                          height={14}
                        />
                        Security Information System (SIEM)
                      </li>
                      <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                        <img 
                          src="images/arrow-right.svg"
                          alt="Arrow Right"
                          width={14}
                          height={14}
                        />
                        DLP Security Solutions
                      </li>
                      <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                        <img 
                          src="images/arrow-right.svg"
                          alt="Arrow Right"
                          width={14}
                          height={14}
                        />
                        UTM
                      </li>
                      <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                        <img 
                          src="images/arrow-right.svg"
                          alt="Arrow Right"
                          width={14}
                          height={14}
                        />
                        SSL VPN
                      </li>
                      <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                        <img 
                          src="images/arrow-right.svg"
                          alt="Arrow Right"
                          width={14}
                          height={14}
                        />
                        Digital Certificates
                      </li>
                    </ul>
                  </div>

                  <div className="mt-4 md:mt-6 security-img-container w-half lg:w-auto md:w-auto">
                      <img
                        src="images/security-solutions.png"
                        alt="Security Solutions Illustration"
                        width={310}
                        height={269}
                        // className="w-full"
                      />
                    </div>

                </div>
                {/* Others */}
                <div className="lg:p-16 md:p-6 p-6 bg-others relative">
                  <h3 className="lg:text-2halfxl md:text-xl text-xl font-semibold offering-title-color">Others</h3>
                  <p className="mt-6 text-sm md:text-lg offering-para-color">
                    Our virtualization solutions improve efficiency, reduce server footprint, and support secure, scalable
                    cloud strategies tailored to your needs.
                  </p>

                  <div className="mt-8 md:mt-6 lg:mt-7 offering_container">
                    <h4 className="text-base lg:text-xl md:text-xl font-bold offering-list-title-color">Our offerings</h4>
                    <ul className="mt-2 md:mt-3 grid gap-1 md:gap-2">
                      <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                        <img 
                          src="images/arrow-right.svg"
                          alt="Arrow Right"
                          width={14}
                          height={14}
                        />
                        Display Solution
                      </li>
                      <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                        <img 
                          src="images/arrow-right.svg"
                          alt="Arrow Right"
                          width={14}
                          height={14}
                        />
                        AV / PA System Solution
                      </li>
                      <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                        <img 
                          src="images/arrow-right.svg"
                          alt="Arrow Right"
                          width={14}
                          height={14}
                        />
                        Virtualization Solution
                      </li>
                      <li className="flex items-center gap-2 text-lg lg:text-lg md:text-sm text-sm offering-list-color">
                        <img 
                          src="images/arrow-right.svg"
                          alt="Arrow Right"
                          width={14}
                          height={14}
                        />
                        Power Backup Solution
                      </li>
                    </ul>
                  </div>

                  <div className="mt-4 md:mt-6 others-img-container w-half lg:w-auto md:w-auto">
                      <img
                        src="images/others.png"
                        alt="Other Solutions Illustration"
                        width={380}
                        height={360}
                        // className="w-full"
                      />
                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Our Services Section */}
        <section className="py-12 md:py-16 bg-service text-white" id="services">
          <div className="container mx-auto px-4">
            <div className="mb-8 md:mb-12">
              <span className="text-coral-600 font-medium md:text-2xl lg:text-2xl">Our Services</span>
              <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-white mt-2">
                Managed IT services customized for your industry
              </h2>
              <p className="mt-4 text-sm md:text-lg text-white/80">
                Reliable, industry-ready IT services tailored to your unique business needs. From support to staffing,
                we deliver custom, secure, and future-ready solutions.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
              {/* IT Support & Service Management */}
              <div className="rounded-lg bg-our-service">
                <div className="mb-4 p-4 pb-0 service-radius-top flex justify-center">
                  <div className="w-half lg:w-auto md:w-auto">
                    <img
                      src="images/it-support.png"
                      alt="IT Support Illustration"
                      width={200}
                      height={150}
                      className="w-auto service-image"
                    />
                  </div>
                </div>
                <div className='p-4 lg:p-8 md:p-6 service-radius-bottom'>
                  <h3 className="text-base md:text-lg lg:text-xl font-semibold service-title-color">IT Support & Service Management</h3>
                  <p className="mt-4 text-xs md:text-sm service-para-color">
                    24/7 responsive helpdesk, ITIL-aligned service delivery, proactive monitoring, and comprehensive
                    support to keep your operations efficient.
                  </p>
                </div>
              </div>

              {/* IT Consulting */}
              <div className="bg-our-service rounded-lg">
                <div className="mb-4 p-4 pb-0 service-radius-top flex justify-center">
                  <div className="w-half lg:w-auto md:w-auto">
                    <img
                      src="images/it-consulting.png"
                      alt="IT Consulting Illustration"
                      width={200}
                      height={150}
                      className="w-auto service-image"
                    />
                  </div>
                </div>
                <div className='p-4 lg:p-8 md:p-6 service-radius-bottom'>
                  <h3 className="text-base md:text-lg lg:text-xl font-semibold service-title-color">IT Consulting</h3>
                  <p className="mt-4 text-xs md:text-sm service-para-color">
                    Strategic advice on IT support for business objectives, security assessments, cloud migration
                    strategies, and enhanced productivity.
                  </p>
                </div>
              </div>

              {/* Facility management Services */}
              <div className="bg-our-service rounded-lg">
                <div className="mb-4 p-4 pb-0 service-radius-top flex justify-center">
                  <div className="w-half lg:w-auto md:w-auto">
                    <img
                      src="images/facility-management.png"
                      alt="Facility Management Illustration"
                      width={200}
                      height={150}
                      className="w-auto service-image"
                    />
                  </div>
                </div>
                <div className='p-4 lg:p-8 md:p-6 service-radius-bottom'>
                  <h3 className="text-base md:text-lg lg:text-xl font-semibold service-title-color">Facility management Services</h3>
                  <p className="mt-4 text-xs md:text-sm service-para-color">
                    IT infrastructure and services for facility management. Comprehensive solutions for modern support
                    from planning to execution.
                  </p>
                </div>
              </div>

              {/* Technology Staffing */}
              <div className="bg-our-service rounded-lg">
                <div className="mb-4 p-4 pb-0 service-radius-top flex justify-center">
                  <div className="w-half lg:w-auto md:w-auto">
                    <img
                      src="images/technology-staffing.png"
                      alt="Technology Staffing Illustration"
                      width={200}
                      height={150}
                      className="w-auto service-image"
                    />
                  </div>
                </div>
                <div className='p-4 lg:p-8 md:p-6 service-para-color'>
                  <h3 className="text-base md:text-lg lg:text-xl font-semibold service-title-color">Technology Staffing Solutions</h3>
                  <p className="mt-4 text-xs md:text-sm offering-para-color">
                    IT resource augmentation for projects and operations. Skilled professionals who understand your
                    business needs and help IT teams to drive success.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Our Partners Section */}
        <section className="bg-service" id="partners">
          <div className="container mx-auto px-4">
            <div className='lg:p-16 md:p-6 p-6 bg-partners'>
              <div className="mb-8 md:mb-12">
                <span className="text-color-red font-semibold text-lg md:text-2xl lg:text-2xl">
                  We work with
                </span>
                <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold offering-title-color mt-2">Our Partners</h2>
              </div>

              <div className="grid grid-cols-3 sm:grid-cols-3 lg:grid-cols-7 gap-4 md:gap-12 lg:gap-12 partner-icon-container">
                <img
                  src="images/dell.png"
                  alt="dell"
                  width={150}
                  height={56}
                />
                <img
                  src="images/vmware.png"
                  alt="vmware"
                  width={150}
                  height={56}
                />
                <img
                  src="images/hpe.png"
                  alt="hp"
                  width={150}
                  height={56}
                />
                <img
                  src="images/aruba.png"
                  alt="aruba"
                  width={150}
                  height={56}
                />
                <img
                  src="images/microsoft.png"
                  alt="microsoft"
                  width={150}
                  height={56}
                />
                <img
                  src="images/ibm.png"
                  alt="ibm"
                  width={150}
                  height={56}
                />
                <img
                  src="images/cisco.png"
                  alt="cisco"
                  width={150}
                  height={56}
                />
                <img
                  src="images/intel.png"
                  alt="intel"
                  width={150}
                  height={56}
                />
                <img
                  src="images/redhat.png"
                  alt="redhat"
                  width={150}
                  height={56}
                />
                <img
                  src="images/nvidia.png"
                  alt="nvidia"
                  width={150}
                  height={56}
                />
                <img
                  src="images/adobe.png"
                  alt="adobe"
                  width={150}
                  height={56}
                />
                <img
                  src="images/sonic.png"
                  alt="sonic"
                  width={150}
                  height={56}
                />
                <img
                  src="images/quest.png"
                  alt="quest"
                  width={150}
                  height={56}
                />
                <img
                  src="images/comm.png"
                  alt="comm"
                  width={150}
                  height={56}
                />
                <img
                  src="images/acu.png"
                  alt="acu"
                  width={150}
                  height={56}
                />
                <img
                  src="images/soph.png"
                  alt="soph"
                  width={150}
                  height={56}
                />
                <img
                  src="images/kasp.png"
                  alt="kasp"
                  width={150}
                  height={56}
                />
                <img
                  src="images/seqr.png"
                  alt="seqr"
                  width={150}
                  height={56}
                />
                <img
                  src="images/hp.png"
                  alt="hp"
                  width={150}
                  height={56}
                />
                <img
                  src="images/lg.png"
                  alt="lg"
                  width={150}
                  height={56}
                />
                <img
                  src="images/solar.png"
                  alt="solar"
                  width={150}
                  height={56}
                />
                <img
                  src="images/schn.png"
                  alt="schn"
                  width={150}
                  height={56}
                />
                <img
                  src="images/samsung.png"
                  alt="samsung"
                  width={150}
                  height={56}
                />
                <img
                  src="images/ips.png"
                  alt="ips"
                  width={150}
                  height={56}
                />
                <img
                  src="images/molex.png"
                  alt="molex"
                  width={150}
                  height={56}
                />
                <img
                  src="images/digi.png"
                  alt="digi"
                  width={150}
                  height={56}
                />
                <img
                  src="images/vault.png"
                  alt="vault"
                  width={150}
                  height={56}
                />
                <img
                  src="images/apc.png"
                  alt="apc"
                  width={150}
                  height={56}
                />
              </div>
            </div>
          </div>
        </section>

        {/* Our Clients Section */}
        <section className="bg-clients" id="clients">
          <div className="container mx-auto px-4">
            <div className='lg:p-16 md:p-6 p-6'>
              <div className="mb-8 md:mb-12">
                <span className="text-color-red font-semibold text-lg md:text-2xl lg:text-2xl">
                  Our partners, our strength and our inspiration
                </span>
                <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold offering-title-color mt-2">Our Esteemed Client</h2>
              </div>

              <div>

                <div className="clients-button-container">
                  {['All', 'Space & Defence', 'Central Govt & Public Sector', 'Govt of Karnataka', 'Institutes', 'Banks'].map(
                    (filter) => (
                      <button
                        key={filter}
                        className={`clients-button ${selectedFilter === filter ? 'selected' : ''}`}
                        onClick={() => handleFilterChange(filter)}
                      >
                        {filter}
                      </button>
                    )
                  )}
                </div>

                <div className="grid grid-cols-3 sm:grid-cols-3 lg:grid-cols-7 gap-4 md:gap-12 lg:gap-12 clients-icon-container">
                  {filteredImages.map((image) => (
                    <img key={image.alt} src={image.src} alt={image.alt} name={image.name} />
                  ))}
                </div>
            </div>

            </div>
          </div>
        </section>

      </main>

      <footer className="footer-bg" id="contact">
        <div className="container mx-auto px-4">
          <div className='lg:p-16 md:p-6 p-6 footer-inner-bg'>
            <div className="flex flex-col md:flex-row items-left gap-110">
              <div className="text-xs md:text-sm footer-text-color text-left company-info-bg">
                <p className='font-semibold text-2xl mb-4 lg:mb-8'>Company Info</p>
                <div className='company-info'>
                  <p className=''><span>CIN:</span><span className='font-semibold'>U72200KA2008PTC046201</span></p>
                  <p><span>PAN:</span><span className='font-semibold'>AACCD8939N</span></p>
                  <p><span>GSTIN:</span><span className='font-semibold'>29AACCD8939N1ZU</span></p>
                  <p><span>IEC:</span><span className='font-semibold'>708007783</span></p>
                  <p><span>TAN:</span><span className='font-semibold'>BLRD06904C</span></p>
                </div>
              </div>

              <div className="text-xs md:text-sm footer-text-color text-left flex gap-48">
                <div>
                  <p className='font-semibold text-2xl mb-4 lg:mb-8'>Karnataka</p>
                  <p className="font-semibold">Dopo Infosystems Pvt Ltd</p>
                  <p className="mt-1 lineheight-24">No. 55, 1st Floor, 1st Block,<br/> 2nd Cross, 30th Main Road,<br/> Banagirinagara, BSK 3rd Stage,<br/> Bangalore – 560 085,<br/> Karnataka, India.</p>
                  <div style={{marginTop: "32px"}}>
                    <div className='flex items-center'><img className='mr-2' src='images/phone-call.svg' width={20} alt='phone-call' />080-26796201</div>
                    <div className='flex items-center mt-2'><img className='mr-2' src='images/deviceMobile.svg' width={20} alt='deviceMobile' />+91 94483 21546</div>
                    <div className='flex items-center mt-2'><img className='mr-2' src='images/mail.svg' width={20} alt='mail' />contact@dopoindia.com</div>
                    <div className='flex items-center mt-2'><img className='mr-2' src='images/mail.svg' width={20} alt='mail' />info@dopoindia.com</div>
                  </div>
                </div>
              </div>

              <div className="text-xs md:text-sm footer-text-color text-left">
                <div>
                  <p className='font-semibold text-2xl mb-4 lg:mb-8'>Tamilnadu</p>
                  <p className="font-semibold">Dopo Infosystems Pvt Ltd</p>
                  <p className="mt-1 lineheight-24">B4, Ceebros Appts,<br/> 11, Cenotaph Road,<br/> Teynampet,Chennai – 600 018<br/> Tamilnadu, India.</p>
                  {/* <div className='flex mt-6 items-center'><img src='images/deviceMobile.svg' width={20} alt='deviceMobile' />+91 94491 53362</div> */}
                </div>
              </div>

              <div className="text-xs md:text-sm footer-text-color text-left">
                <div>
                  <p className='font-semibold text-2xl mb-4 lg:mb-8'>Kerala</p>
                  <p className="font-semibold">Dopo Infosystems Pvt Ltd</p>
                  <p className="mt-1 lineheight-24">Pulliyarathoppu, Lane Kalady,<br/> Karaman P.O., Thiruvananthapuram,<br/> Kerala – 695 002</p>
                  {/* <div className='flex mt-6 items-center'><img src='images/deviceMobile.svg' width={20} alt='deviceMobile' />+91 98459 98640</div> */}
                </div>
              </div>

            </div>
          </div>
        </div>
      </footer>
      <div className='copyright'>
        <div>© 2025 Dopo Infosystems Pvt Ltd</div>
      </div>
      {showAbout && <About close={() => setShowAbout(false)}/>}
      {showContact && <Contact close={() => setShowContact(false)}/>}
    </div>
  );
}